import { themeGet, styled } from '@qwealth/qcore';
import Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';

export const Label = styled.div`
  font-size: ${themeGet('fontSizes.small')};
  font-weight: 700;
  text-transform: capitalize;
  margin-bottom: 0.5em;
`;

export const DateTimeStyle = styled(Datetime)`
  input {
    border: 1px solid ${themeGet('colors.gray.3')} !important;

    &:focus {
      border-color: ${themeGet('colors.primaryLight.0')};
      box-shadow: ${themeGet('shadows.inputFocus')};
      outline: 0;
    }
  }

  .rdtTimeToggle {
    background: #865070;
    color: #fff;
    font-size: 1.5em;
    font-weight: 700;
    padding: 0.25em;

    :hover {
      
      color: #865070;
    }
  }
`;
